import Button from "../../../components/buttons/button";

const LeaveRequestDetails = ({ t, selected, setOpen }) => {
  const color =
    selected.status === "تم الموافقة"
      ? "#11A849"
      : selected.status === "مرفوض"
      ? "#C42E27"
      : "#F59E0B";
  return (
    <section className="p-4 space-y-3 rounded-lg bg-sideBar">
      <h3 className="font-bold">{t("financialAccountDetails")}</h3>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("employee")}:</p>
          <p>{selected.employee}</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("vacationType")}:</p>
          <p>{selected.type}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("startDate")}:</p>
          <p className="text-xl font-semibold">{selected.startDate}</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("endDate")}:</p>
          <p className="text-xl font-semibold">{selected.endDate}</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("numberOfDays")}:</p>
          <p className="text-xl font-semibold">{selected.days}</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("reason")}:</p>
          <p className="text-xl font-semibold">ظروف عائلية</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("status")}</p>
          <p className="text-xl font-semibold" style={{ color }}>
            {selected.status}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3">
        {selected.status === "يراجع" && (
          <>
            <Button
              type={"button"}
              className={"bg-[#11A849] justify-center w-[130px] text-white text-sm"}
              onClick={() => setOpen(false)}
            >
              {t("accept")}
            </Button>
            <Button
              className={"bg-[#C42E27] text-white text-sm"}
              type="button"
              onClick={() => setOpen(false)}
            >
              {t("reject")}
            </Button>
          </>
        )}
        <Button
          className={"border border-primary text-white text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
    </section>
  );
};

export default LeaveRequestDetails;
